import React from 'react';

import { Typography } from '~/ui/components';
import { UserPlus } from 'react-feather';
import { useTheme } from 'styled-components';
import { IconArea, StatisticsCardContainer, TextArea } from './StatisticsCard.styled';

interface StatisticsCardsProps {
  title: string;
  description: string;
  titleColor?: string;
  descriptionColor?: string;
}

export function StatisticsCard({ title, description, titleColor, descriptionColor }: StatisticsCardsProps) {
  const { colors } = useTheme();
  const resolvedTitleColor = titleColor ?? colors.element.secondary;
  const resolvedDescriptionColor = descriptionColor ?? colors.element.primary;
  return (
    <StatisticsCardContainer>
      <IconArea>
        <UserPlus color={colors.brand.primary} height={30} width={30} data-testid="user-plus-icon" />
      </IconArea>
      <TextArea>
        <Typography type="footnote" color={resolvedTitleColor} element="p" weight={500}>
          {title}
        </Typography>
        <Typography type="caption" color={resolvedDescriptionColor} element="p" weight={600}>
          {description}
        </Typography>
      </TextArea>
    </StatisticsCardContainer>
  );
}
